import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable()
export class ValidTokenAuthGuard  {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate() {
    const accessTokenIsValid = this.authService.userHasValidAccessToken();
    if (accessTokenIsValid) {
      return true;
    } else {
      this.router.navigate(['/']);
      return false;
    }
  }
}
